export const HOST_SERVER = process.env.REACT_APP_HOST_SERVER || "http://localhost:5000";
